import { isPublicMarketingPath } from "utils/fullstory";

export function shouldBlockAppShellOnAuth({
  pathname,
  isLoading,
  authUser,
  isOAuthCallbackRoute,
  hasLikelyAuthSession = false,
}) {
  if (!isLoading || isOAuthCallbackRoute) {
    return false;
  }

  if (authUser) {
    return true;
  }

  // authUser is undefined until onAuthStateChanged fires. A stored session hint
  // means this browser was recently signed in, so hold the spinner instead of
  // painting marketing. Confirmed signed-out (null) still paints immediately.
  if (authUser === undefined && hasLikelyAuthSession) {
    return true;
  }

  return !isPublicMarketingPath(pathname);
}
